export default __webpack_public_path__ + "static/grandangolo-3-befd287951ebe4fe562e2a5cd3184c31.jpg";